var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEvent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6E7481",
  d: "M3.333 10v5q0 2.5 2.5 2.5h8.334q2.5 0 2.5-2.5v-5",
  opacity: 0.4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6E7481",
  d: "M17.5 7.083c0-.69-.56-1.25-1.25-1.25h-.887c.161-.314.262-.665.262-1.041A2.294 2.294 0 0 0 13.333 2.5c-.685 0-1.329.305-1.771.842L10 5.417c-.603-.802-1.54-2.049-1.567-2.081A2.28 2.28 0 0 0 6.667 2.5a2.294 2.294 0 0 0-2.292 2.292c0 .376.1.727.262 1.041H3.75c-.69 0-1.25.56-1.25 1.25V10h6.875v7.5h1.25V10H17.5zM6.667 5.833a1.043 1.043 0 0 1-1.042-1.041c0-.574.468-1.042 1.042-1.042.315 0 .599.135.79.367l1.291 1.716zm6.666 0h-2.081l1.28-1.702c.202-.245.486-.381.801-.381.575 0 1.042.468 1.042 1.042s-.467 1.041-1.042 1.041"
})));
export default SvgEvent;